import React from 'react';
import { useHistory } from 'react-router';
// import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import EditIcon from '@material-ui/icons/Edit';

export default function FormDialog({ row, saveRow, pageName, show, editpageName, rows, props, onClick, selectedImc }) {
    const history = useHistory();

    const theme = createMuiTheme({
        typography: {
            fontFamily: [
                '-apple-system',
                'BlinkMacSystemFont',
                '"Segoe UI"',
                'Roboto',
                'Rubik',
                '"Helvetica Neue"',
                'Arial',
                'sans-serif',
                '"Apple Color Emoji"',
                '"Segoe UI Emoji"',
                '"Segoe UI Symbol"',
            ].join(','),
        },
    });

    // const theme = createMuiTheme();

    theme.typography.h3 = {
        fontSize: '1.2rem',
        '@media (min-width:600px)': {
            fontSize: '1.5rem',
        },
        [theme.breakpoints.up('md')]: {
            fontSize: '2rem',
        },
    };

    const handleClickOpen = () => {
        //console.log('aaaa', row)
        if (pageName === 'imc') {
            history.push({
                pathname: '/menu/updateimc',
                state: { row },
            });
        }
        if (pageName === 'itec') {
            history.push({
                pathname: '/menu/updateitec',
                state: { row },
            });
        }
        if (pageName === 'individual') {
            history.push({
                pathname: '/menu/updateindividual',
                state: { row },
            });
        }
        if (pageName === 'corporate') {
            history.push({
                pathname: '/menu/updatecorporate',
                state: { row },
            });
        }
        if (pageName === 'colleague') {
            history.push({
                pathname: '/menu/UpdateColleague',
                state: { row },
            });
        }
        if (pageName === 'core') {
            history.push({
                pathname: '/menu/updatecore',
                state: { row },
            });
        }
        if (pageName === 'bankclientsedit') {
            history.push({
                pathname: '/menu/editbankdetails',
                state: { row },
            });
        }
        if (pageName === 'adminbanksedit') {
            history.push({
                pathname: '/menu/adminedit-bankdetails',
                state: { row },
                imcClient: { editpageName },
            });
        }
        if (pageName === 'servicesedit') {
            console.log('servicesedit-->row', row);
            history.push({
                pathname: '/menu/updateservice',
                state: { row, selectedImc },
            });
        }
    };

    // const onClick = (event) => {
    //   //console.log("onClick");
    //   setInputValue(event.target.value);
    //   // if (props.onClick) props.onClick(inputValue);
    // };

    return (
        <>
            <ThemeProvider theme={theme}>
                {show === 'editIcon' && (
                    <Tooltip title="Edit" onClick={handleClickOpen}>
                        <IconButton aria-label="Edit">
                            <EditIcon />
                        </IconButton>
                    </Tooltip>
                )}
                {/* {show === 'AddIcon' && (
                    <Tooltip title="Add" onClick={onClick}>
                        <IconButton aria-label="Edit">
                            <AddCircleOutlineIcon />
                        </IconButton>
                    </Tooltip>
                )} */}

                {/* <IconButton aria-label="Edit" onClick={onClick}>
          <AddCircleOutlineIcon />
        </IconButton> */}

                {/* <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
                    {pageName === 'ravi' && <EditBankDetails />}
                </Dialog> */}
            </ThemeProvider>
        </>
    );
}
